import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const addCharityBeneficiaryFeatureKey = 'addCharityBeneficiary';

export interface AddCharityBeneficiaryState {
  addCharityBeneficiaryResponse: string | null;
  addCharityBeneficiaryFailure: Error | any;
}

export const initialState: AddCharityBeneficiaryState = {
  addCharityBeneficiaryResponse: null,
  addCharityBeneficiaryFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.addCharityBeneficiarySuccess, (state, action) => ({
    ...state,
    addCharityBeneficiaryResponse: action.response
  })),
  on(actions.addCharityBeneficiaryFailure, (state, action) => ({
    ...state,
    addCharityBeneficiaryFailure: action.error
  }))
);
